import { useState, useEffect } from 'react';

const SKILLS = ['DRIBBLING', 'PASSING', 'SHOOTING', 'DEFENDING', 'TACKLING', 'HEADING', 'FIRST TOUCH', 'POSITIONING'];

export default function AddActivityForm({ onSubmit, onCancel, initialActivity = null }) {
  const [activity, setActivity] = useState({
    ActivityName: '',
    SkillTags: '',
    Instructions: '',
    VideoURL: ''
  });
  const [selectedSkills, setSelectedSkills] = useState([]);

  useEffect(() => {
    if (initialActivity) {
      setActivity(initialActivity);
    }
  }, [initialActivity]);

  const handleSkillToggle = (skill) => {
    setSelectedSkills(prev => 
      prev.includes(skill)
        ? prev.filter(s => s !== skill)
        : [...prev, skill]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(activity);
    setActivity({
      ActivityName: '',
      SkillTags: '',
      Instructions: '',
      VideoURL: ''
    });
    setSelectedSkills([]);
  };

  return (
    <div className="bg-white p-6 rounded-lg max-w-2xl w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">
          {initialActivity ? 'Edit Activity' : 'Add New Activity'}
        </h2>
        <button
          onClick={onCancel}
          className="text-gray-500 hover:text-gray-700"
        >
          ×
        </button>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Activity Name
          </label>
          <input
            type="text"
            value={activity.ActivityName}
            onChange={(e) => setActivity({ ...activity, ActivityName: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Skill Tags (comma-separated)
          </label>
          <input
            type="text"
            value={activity.SkillTags}
            onChange={(e) => setActivity({ ...activity, SkillTags: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Instructions
          </label>
          <textarea
            value={activity.Instructions}
            onChange={(e) => setActivity({ ...activity, Instructions: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 h-32"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Video URL (optional)
          </label>
          <input
            type="url"
            value={activity.VideoURL}
            onChange={(e) => setActivity({ ...activity, VideoURL: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
          >
            {initialActivity ? 'Save Changes' : 'Add Activity'}
          </button>
        </div>
      </form>
    </div>
  );
} 